var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoH({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 309.03 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.51,0C-.68,3.22.21,6.98,3.1,9.81c4.03,3.95,8.13,7.82,12.19,11.73,6.31,6.09,12.63,12.17,18.91,18.28,1.93,1.87,2.46,3.73,1.76,5.85-9.53-9.17-19.02-18.29-28.81-27.71-.79,4.24.32,7.27,3.05,9.87,7.18,6.85,14.31,13.76,21.45,20.64,1.64,1.58,2.46,3.46,2.11,6.21-6.77-6.49-13.29-12.74-20.05-19.23-.75,3.83.16,6.69,2.65,9.08,4.99,4.81,9.98,9.63,14.97,14.43,1.04,1,2.12,1.95,3.36,3.09,2.12-5.67,4.25-10.96,6.06-16.35,1.15-3.42.26-6.65-2.35-9.18C25.79,24.31,13.11,12.13.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.38,23.07c-2.29-2.45-4.82-4.67-7.25-6.99-.17.07-.34.14-.51.21.16,1.03.32,2.07.44,2.82-2.61.97-5.17,1.93-7.78,2.91-.67-4.12-3.47-7.04-6.48-9.87-1.31-1.23-2.61-2.48-3.91-3.73-2.76-2.65-5.51-5.32-8.28-7.99-1.62,3.2-1.04,6.84,1.9,9.74.94.92,1.89,1.84,2.83,2.76,4.55,4.43,9.14,8.83,13.71,13.24,2.66,2.57,5.34,5.12,8,7.67.41-1.69.48-3.35,1.23-4.61.65-1.1,1.97-2.23,3.16-2.43.89-.15,2.03,1.14,3.13,1.82,1.11-1.14,1.3-3.98-.18-5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.26,51.72c-.74,3.42-.3,5.86,1.74,7.9,2.01,2.01,4.12,3.93,6.12,5.96,1.26,1.29,2.17,2.76.95,5.41-1.51-1.92-2.78-3.54-4.05-5.16-.19.16-.37.31-.56.47,1.43,3.67,2.85,7.33,4.28,11,.16,0,.32,0,.47.01,1.13-3.15,2.36-6.27,3.37-9.46.6-1.9-.17-3.57-1.55-4.98-3.48-3.57-6.94-7.17-10.78-11.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.7 93.14 30.29 90.57 33.65 91.66 31.88 88.84 33.33 86.71 30.12 86.86 28.03 84.8 27.67 87.33 24.43 88.36 27.52 89.72 27.7 93.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.57 92.99 21.15 91.06 20.19 93.81 17.36 95.23 19.63 96.29 19.5 99.72 21.9 97.19 25.25 97.99 23.73 94.97 25.92 92.22 22.57 92.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.74 91.85 18.26 89.07 20.84 88.5 19.52 87.16 20.81 85.02 18.65 86.52 17.62 86.16 16.92 87.88 15.22 89.69 16.66 89.46 16.74 91.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.67 82.62 23.87 82.36 23.65 83.43 21.32 84.79 23.71 84.69 24.21 86.55 25.93 84.47 29.12 84.33 27.1 83.13 28.16 81.9 25.67 82.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.87 97.29 13.81 95.79 13.79 98.5 12.99 99.98 14.07 100.64 14.77 103.47 15.29 101.04 17.38 101.26 15.89 98.8 16.56 95.81 14.87 97.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.09 104.69 19.74 105.63 17.92 103.41 18.24 106.45 17.06 107.33 18.88 108.6 19.96 111.2 20.72 109.46 23.27 110.12 21.3 107.65 22.09 104.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.8 101.74 27.16 98.34 25.95 102 22.81 102.58 25.21 104.79 24.95 108.28 27.68 106.43 30.94 108.2 29.9 104.51 32.53 101.9 28.8 101.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.89 94.54 34.98 91.1 33.98 94.71 30.26 95.31 33.21 97.64 32.75 101.31 35.82 99.17 38.73 100.69 37.86 97.2 40.05 94.66 36.89 94.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.86 84.56 32.64 85.43 35.73 86.28 37.01 88.87 37.97 86.86 40.39 87.61 38.3 85.56 38.2 84.21 36.41 84.27 33.97 82.97 34.86 84.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.77,90.05l-1.51.52-2.24-2.11.89,2.94-2.07,1.26,2.8.99,1.04,3.36s.79-1.99.89-2.8l1.72.43-1.45-2.38-.06-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.61,96.66l.69-2.37,1.28-.42-.6-1.48,1-2.41-1.33,1.5-.04-.51c-.42.75-1.21,3.32-1.21,3.32l.22-.04-.02,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.63,101.9l-.07-2.39-.51.89c.11,1.84.6,2.7.6,2.7l.73.57-.75-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.11,107.14l-.13-1.52-.71.33-1.04-1.46s1,3.14,2.36,4.49l.06-.29,1.1.82-1.63-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.17,111.2l-1.15-.05-1.66-1.46s2.87,3.32,4.71,3.71l-1.79-1.22-.11-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.23,84.87l-.4-.13.81-.94c-.35.23-.68.47-.98.71-1.8,1.46-2.64,2.97-2.64,2.97,1.03-1.62,3.21-2.61,3.21-2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.87,83.31c1.64-1.48,3.83-1.64,3.83-1.64-2.25-.21-4.79,1.35-4.79,1.35l.92-.27.04.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.1,82.09l1,1.35,1.14-1.02c.8.01,2.29.43,2.29.43-.27-.31-1.93-.94-1.93-.94l.23-.34c-.41-.23-3.63-.57-3.63-.57l.21.5c-1.05.06-1.91.43-1.91.43.97-.04,2.6.17,2.6.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.66,87.15l.03-.72.85.66c-.53-.74-3.76-3.47-3.76-3.47l.55.78-.61-.03c1.77.61,2.95,2.78,2.95,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.19,92.79c-.61-1.85-2.79-4.45-2.79-4.45l.88,1.67-.58.64c1.92,1.04,2.31,3.4,2.31,3.4.05-.66-.07-1.47-.07-1.47l.25.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.93,48.04v-.49c0-5.06,3.3-8.75,8.6-8.75s8.62,3.69,8.62,8.75v.49c0,5.06-3.3,8.75-8.62,8.75s-8.6-3.69-8.6-8.75ZM71.64,37.27v-3.76h3.86v3.76h-3.86ZM80.87,48.04v-.49c0-3.27-1.54-5.35-4.35-5.35s-4.32,2.08-4.32,5.35v.49c0,3.27,1.56,5.35,4.32,5.35s4.35-2.08,4.35-5.35ZM77.6,37.27v-3.76h3.86v3.76h-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.18,50.8h4.08c.24,1.83,1.56,2.76,3.62,2.76,1.83,0,2.91-.68,2.91-1.86v-.1c0-1.17-.78-1.69-4.05-2.27-4.18-.76-5.96-2.32-5.96-5.18v-.17c0-3.18,2.83-5.18,6.74-5.18s6.79,1.98,7.08,5.62h-4.08c-.17-1.64-1.27-2.42-3.08-2.42s-2.59.78-2.59,1.81v.07c0,1,.49,1.56,3.79,2.1,3.98.66,6.25,2.15,6.25,5.16v.2c0,3.37-2.98,5.45-7.11,5.45-4.59,0-7.35-2.25-7.6-5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.04,56.47v-14h-4.79v-3.35h13.68v3.35h-4.76v14h-4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.71,56.47v-17.34h12.8v3.35h-8.75v3.54h7.84v3.25h-7.84v3.86h8.94v3.35h-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.72,56.47v-17.34h7.87c3.69,0,6.45,1.95,6.45,5.62v.25c0,2.64-1.39,4.37-3.57,5.15l4.08,6.33h-4.52l-3.62-5.86h-2.61v5.86h-4.08ZM135.79,47.26h3.35c1.56,0,2.64-.68,2.64-2.27v-.25c0-1.59-1.07-2.27-2.64-2.27h-3.35v4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.99,56.47v-17.34h7.87c3.69,0,6.45,1.95,6.45,5.62v.25c0,2.64-1.39,4.37-3.57,5.15l4.08,6.33h-4.52l-3.62-5.86h-2.61v5.86h-4.08ZM152.06,47.26h3.35c1.56,0,2.64-.68,2.64-2.27v-.25c0-1.59-1.07-2.27-2.64-2.27h-3.35v4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.26,56.47v-17.34h12.8v3.35h-8.75v3.54h7.84v3.25h-7.84v3.86h8.94v3.35h-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.38,56.47v-17.34h4.15v17.34h-4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.61,48.04v-.49c0-5.11,3.37-8.75,8.55-8.75,4.5,0,7.48,2.81,7.72,7.04h-4.15c-.17-2.32-1.54-3.64-3.64-3.64-2.71,0-4.2,2.15-4.2,5.35v.49c0,3.2,1.51,5.33,4.23,5.33,2.1,0,3.49-1.37,3.59-3.79h4.15c-.22,4.32-3.1,7.21-7.72,7.21-5.28,0-8.53-3.64-8.53-8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.69,56.47v-17.34h4.13v6.77h6.94v-6.77h4.13v17.34h-4.13v-7.21h-6.94v7.21h-4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.45,56.47v-17.34h4.15v17.34h-4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.55,50.8h4.08c.24,1.83,1.56,2.76,3.62,2.76,1.83,0,2.91-.68,2.91-1.86v-.1c0-1.17-.78-1.69-4.05-2.27-4.18-.76-5.96-2.32-5.96-5.18v-.17c0-3.18,2.83-5.18,6.74-5.18s6.79,1.98,7.08,5.62h-4.08c-.17-1.64-1.27-2.42-3.08-2.42s-2.59.78-2.59,1.81v.07c0,1,.49,1.56,3.79,2.1,3.98.66,6.25,2.15,6.25,5.16v.2c0,3.37-2.98,5.45-7.11,5.45-4.59,0-7.35-2.25-7.6-5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.48,48.04v-.49c0-5.11,3.37-8.75,8.55-8.75,4.5,0,7.48,2.81,7.72,7.04h-4.15c-.17-2.32-1.54-3.64-3.64-3.64-2.71,0-4.2,2.15-4.2,5.35v.49c0,3.2,1.51,5.33,4.23,5.33,2.1,0,3.49-1.37,3.59-3.79h4.15c-.22,4.32-3.1,7.21-7.72,7.21-5.28,0-8.53-3.64-8.53-8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.56,56.47v-17.34h4.13v6.77h6.94v-6.77h4.13v17.34h-4.13v-7.21h-6.94v7.21h-4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.2,56.47v-17.34h12.8v3.35h-8.75v3.54h7.84v3.25h-7.84v3.86h8.94v3.35h-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.2,56.47v-17.34h7.87c3.69,0,6.45,1.95,6.45,5.62v.25c0,2.64-1.39,4.37-3.57,5.15l4.08,6.33h-4.52l-3.62-5.86h-2.61v5.86h-4.08ZM298.28,47.26h3.35c1.56,0,2.64-.68,2.64-2.27v-.25c0-1.59-1.07-2.27-2.64-2.27h-3.35v4.79Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.21,75.61v-13.68h.81v7.92l7.63-7.92h1.08l-5.7,5.88,5.9,7.8h-1l-5.47-7.23-2.43,2.5v4.72h-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.7,75.61v-13.68h.81v12.95h6.42v.73h-7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.84,75.61v-13.68h8.46v.73h-7.65v5.57h6.98v.73h-6.98v5.92h7.69v.73h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.82,75.61v-13.68h.81v13.68h-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.66,75.61v-13.68h.93l8.36,12.41v-12.41h.81v13.68h-.89l-8.4-12.49v12.49h-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.76,75.61v-13.68h7.96v.73h-7.15v5.61h6.42v.73h-6.42v6.61h-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.96,75.61v-13.68h8.46v.73h-7.65v5.57h6.98v.73h-6.98v5.92h7.69v.73h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.93,75.61v-13.68h.81v12.95h6.42v.73h-7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.06,75.61v-13.68h4.09c3.78,0,6.38,2.29,6.38,6.53v.62c0,4.22-2.58,6.53-6.38,6.53h-4.09ZM150.87,74.88h3.14c3.55,0,5.67-2.04,5.67-5.8v-.62c0-3.76-2.1-5.8-5.67-5.8h-3.14v12.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.29,75.61v-13.68h7.96v.73h-7.15v5.61h6.42v.73h-6.42v6.61h-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.08,70.58v-8.65h.81v8.61c0,3.03,1.58,4.53,4.24,4.53s4.24-1.52,4.24-4.55v-8.59h.81v8.65c0,3.24-1.73,5.26-5.05,5.26s-5.05-2.02-5.05-5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.17,71.55h.85c.21,2.51,2.04,3.55,4.3,3.55s3.93-1.1,3.93-2.97v-.17c0-1.85-1.68-2.54-4.18-2.95-2.87-.46-4.38-1.45-4.38-3.49v-.19c0-2,1.77-3.62,4.39-3.62,2.49,0,4.37,1.29,4.72,3.83h-.85c-.31-2.04-1.77-3.08-3.87-3.08s-3.58,1.16-3.58,2.87v.17c0,1.72,1.43,2.37,3.78,2.76,2.85.48,4.78,1.37,4.78,3.66v.19c0,2.2-1.93,3.74-4.78,3.74s-4.95-1.45-5.11-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.31,71.55h.85c.21,2.51,2.04,3.55,4.3,3.55s3.93-1.1,3.93-2.97v-.17c0-1.85-1.68-2.54-4.18-2.95-2.87-.46-4.38-1.45-4.38-3.49v-.19c0-2,1.77-3.62,4.39-3.62,2.49,0,4.37,1.29,4.72,3.83h-.85c-.31-2.04-1.77-3.08-3.87-3.08s-3.58,1.16-3.58,2.87v.17c0,1.72,1.43,2.37,3.78,2.76,2.85.48,4.78,1.37,4.78,3.66v.19c0,2.2-1.93,3.74-4.78,3.74s-4.95-1.45-5.11-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.47,75.61v-13.68h4.84c2.43,0,4.14,1,4.14,3.33v.21c0,1.68-1.14,2.52-2.08,2.87,1.48.35,2.74,1.48,2.74,3.35v.25c0,2.33-1.73,3.66-4.28,3.66h-5.36ZM212.28,68.08h4.12c1.93,0,3.22-.89,3.22-2.6v-.21c0-1.75-1.21-2.6-3.3-2.6h-4.05v5.42ZM212.28,74.88h4.62c1.99,0,3.39-1.04,3.39-2.93v-.25c0-1.89-1.37-2.91-3.51-2.91h-4.51v6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.96,75.61l-1.71-4.32h-6.65l-1.72,4.32h-.83l5.45-13.68h.87l5.43,13.68h-.85ZM224.89,70.56h6.07l-3.03-7.65-3.04,7.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.62,75.61v-13.68h.81v12.95h6.42v.73h-7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.76,75.61v-13.68h.81v12.95h6.42v.73h-7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.29,75.61v-13.68h4.84c2.43,0,4.14,1,4.14,3.33v.21c0,1.68-1.14,2.52-2.08,2.87,1.48.35,2.74,1.48,2.74,3.35v.25c0,2.33-1.73,3.66-4.28,3.66h-5.36ZM258.1,68.08h4.12c1.93,0,3.22-.89,3.22-2.6v-.21c0-1.75-1.21-2.6-3.3-2.6h-4.05v5.42ZM258.1,74.88h4.62c1.99,0,3.39-1.04,3.39-2.93v-.25c0-1.89-1.37-2.91-3.51-2.91h-4.51v6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.14,70.58v-8.65h.81v8.61c0,3.03,1.58,4.53,4.24,4.53s4.24-1.52,4.24-4.55v-8.59h.81v8.65c0,3.24-1.73,5.26-5.05,5.26s-5.05-2.02-5.05-5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.17,75.61v-13.68h.93l8.36,12.41v-12.41h.81v13.68h-.89l-8.4-12.49v12.49h-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.28,75.61v-13.68h4.09c3.78,0,6.38,2.29,6.38,6.53v.62c0,4.22-2.58,6.53-6.38,6.53h-4.09ZM296.09,74.88h3.14c3.55,0,5.67-2.04,5.67-5.8v-.62c0-3.76-2.1-5.8-5.67-5.8h-3.14v12.22Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoH);
export default __webpack_public_path__ + "static/media/LogoH.a57be97a0516f5705a0babf85d4afd60.svg";
export { ForwardRef as ReactComponent };